<template>
  <tr class="popular-account">
    <td>
      <a
        v-bind:href="apyLink"
        v-bind:onclick="apyNavigation"
      >{{$filters.percentageFilter(popularAccount.Account.Apy)}}</a>
    </td>
    <td class="hidden-xs">{{productName}}</td>
    <td class="compare-column">
      <div v-if="isAdAccount">
        <b>{{$filters.percentageFilter(popularAccount.Ad.account.apy)}}</b> -
        <a v-on:click.prevent="trackAdLink(popularAccount.Ad)">
          {{accountDisplayName}}
          <span class="openAccount">OPEN ACCOUNT ></span>
        </a>
        <img
          class="ad-pixel"
          width="1"
          height="1"
          alt
          v-bind:src="$filters.formatTrackingFilter(popularAccount.Ad.pixel)"
        >
      </div>
      <div v-else>
        <b>{{$filters.percentageFilter(popularAccount.NationalRate)}}</b> -
        <a v-bind:href="popularAccount.Product.FullUrl">National Average</a>
      </div>
    </td>
  </tr>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import "../../../utils/filters";
import { adClickMixin } from "../../../mixins/adClickMixin";

export default defineComponent({
  name: "popular-account-non-advertiser",
  mixins: [adClickMixin],
  props: {
    popularAccount: Object
  },
  computed: {
    apyLink: function() {
      return "#a" + this.popularAccount.Account.Id;
    },
    apyNavigation: function() {
      return (
        "$('a[data-account=" + this.popularAccount.Account.Id + "]').trigger('click');"
      );
    },
    productName: function() {
      if (this.popularAccount.Product != null) {
        return this.popularAccount.Product.ShortName;
      }
      return this.popularAccount.Ad.SectionName;
    },
    isAdAccount: function() {
      return this.popularAccount.Ad != null;
    },
    accountDisplayName: function() {
      if (this.popularAccount.Ad.adCopy) {
        return this.popularAccount.Ad.adCopy;
      }
      return (
        this.popularAccount.Ad.account.bankName +
        " " +
        this.popularAccount.Ad.account.name
      );
    }
  }
});
</script>
<style lang="scss" scoped>
.popular-account td {
  &:first-child {
    font-size: 16px;
    text-align: center;
  }
  vertical-align: inherit;
  border-bottom: 1px solid #ddd;
  border-top: none;
  font-weight: bold;

  &:last-child {
    background-color: #eee;
    font-weight: normal;
    a {
      color: #666666;
      font-weight: 600;
      cursor: pointer;
    }
    b {
      color: #666666;
      font-size: 16px;
      font-weight: 700;
    }
  }
}
.openAccount {
  float: right;
  font-weight: 600;
  color: #ffba1a;
  padding-top: 3px;
}
</style>